// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import LemonIMUI from 'lemon-imui'
import 'lemon-imui/dist/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import './permission'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
// import permission from '@/directive/permission/index.js' // 权限判断指令
// Vue.use(permission)
Vue.use(ElementUI)
Vue.use(LemonIMUI)
Vue.config.productionTip = false
// 全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('real-img', async function (el, binding) { // 指令名称为：real-img
  const imgURL = binding.value// 获取图片地址
  if (imgURL) {
    const exist = await imageIsExist(imgURL.split(',')[0])
    if (exist) {
      el.setAttribute('src', imgURL.split(',')[0])
    } else {
      el.setAttribute('src', 'https://nmzp.com/static/img/zwtp.223ebd5.jpg')
    }
  }
})
/**
 * 检测图片是否存在
 * @param url
 */
const imageIsExist = function (url) {
  return new Promise((resolve) => {
    var img = new Image()
    img.onload = function () {
      if (this.complete === true) {
        resolve(true)
        img = null
      }
    }
    img.onerror = function () {
      resolve(false)
      img = null
    }
    img.src = url
  })
}

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js